(function () {
    angular
      .module('kareo.ui.shared.directives.k-enrl-ready-payers', [
        'kareo.ui.shared.modules.api.enrollments-service',
        'kareo.ui.shared.modules.data',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kEnrlReadyPayers', kEnrlReadyPayers);
  
    function kEnrlReadyPayers() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          payers: '='
        },
        template: require('./k-enrl-ready-payers.pug')()
      };
  
      return directive;
    }
  
    //----------------------
  
    controller.$inject = ['$filter', '$scope', 'enrollmentsService', 'featureSet', 'practice'];
  
    function controller($filter, $scope, enrollmentsService, featureSet, practice) {
      const vm = this;
      const filterOutStatus = {
        IN_PROGRESS: true,
        NOT_AVAILABLE: true,
        PENDING_PAYER: true,
        PENDING_PRACTICE: true,
        READY: true,
        LIVE: true
      };
  
      vm.addPayer = addPayer;
      vm.visibleReadyPayers = visibleReadyPayers;
  
      init();
  
      //----------------------
  
      function init() {
        vm.hasError = false;
        vm.isLoading = true;
        vm.isPhase2Feature = false;
  
        enrollmentsService.getPayerDetails(true).then((payers) => {
          vm.hasError = false;
          vm.isLoading = false;
          vm.readyPayers = nonCustomPayers(payers);
          startWatch();
        }, () => {
          vm.isLoading = false;
          vm.hasError = true;
        });
  
        featureSet.load().then((features) => {
          vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
          vm.isPhase2Feature = features['dark-feature.enrollments-upgrade-phase2']
                            || features['dark-feature.enrollments-upgrade-phase3'];
        });
  
        practice.get().then((result) => {
          vm.isPmEnabled = result.pmenabled;
        });
      }
  
      function addPayer(payer) {
        vm.payers = [];
        vm.payers = [payer];
      }
  
      function startWatch() {
        $scope.$watch('vm.payers.length', () => {
          const selectedInsuranceCompanies = {};
          for (let spi = 0; spi < vm.payers.length; spi++) {
            const selectedPayer = vm.payers[spi];
            selectedInsuranceCompanies[selectedPayer.insuranceCompanyId] = true;
          }
          for (let rpi = 0; rpi < vm.readyPayers.length; rpi++) {
            const readyPayer = vm.readyPayers[rpi];
            readyPayer.isAdded = !!selectedInsuranceCompanies[readyPayer.insuranceCompanyId];
          }
        });
      }
  
      function nonCustomPayers(payers) {
        return $filter('filter')(payers, (payer) => !payer.isCustom && enrollablePayer(payer));
      }
  
      function enrollablePayer(payer) {
        // none of them should be IN_ELIGIBLE
        return (
          payer.claimsStatusDisplay.status !== 'IN_ELIGIBLE' &&
          payer.eligibilityStatusDisplay.status !== 'IN_ELIGIBLE' &&
          payer.eraStatusDisplay.status !== 'IN_ELIGIBLE'
        )
        && // and should not be in the listed statuses
        (!filterOutStatus[payer.claimsStatusDisplay.status]
          || !filterOutStatus[payer.eligibilityStatusDisplay.status]
          || !filterOutStatus[payer.eraStatusDisplay.status]
        );
      }
  
      function visibleReadyPayers() {
        return $filter('filter')(vm.readyPayers, (payer) => !payer.isAdded);
      }
    }
  })();
  